import get from 'lodash.get';
import { flatten } from 'flat';

export const formatDateTime = date => {
  const todayFormatted = new Date().toLocaleDateString('en-GB');
  const yesterdayFormatted = new Date(new Date().setDate(new Date().getDate() - 1)).toLocaleDateString('en-GB');
  const orderDateFormatted = new Date(date).toLocaleDateString('en-GB');
  const timeFormatOptions = { hour: 'numeric', minute: 'numeric', hour12: true };

  if (todayFormatted === orderDateFormatted) {
    return `Today ${new Date().toLocaleTimeString('en-GB', timeFormatOptions)}`;
  }

  if (yesterdayFormatted === orderDateFormatted) {
    return `Yesterday ${new Date().toLocaleTimeString('en-GB', timeFormatOptions)}`;
  }
  return `${orderDateFormatted} ${new Date(date).toLocaleTimeString('en-GB', timeFormatOptions)}`;
};

export const formatAddress = address => {
  const { city, addressLine1, country } = address;

  return `${addressLine1 ? `${addressLine1}, ` : ''}${city ? `${city}/` : ''}${country || ''}`;
};

export const formatDateTimeHumanFriendly = date => {
  const timeFormatOptions = {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour12: false,
    hour: '2-digit',
    minute: '2-digit'
  };

  return new Date(date).toLocaleDateString('en-GB', timeFormatOptions);
};

export const formatDate = date => new Date(date).toLocaleDateString('en-GB');

export const withFund = line => `£ ${line}`;

const base64Regexp = /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)?$/;

const isBase64 = line => {
  if (!line) return false;
  if (typeof line !== 'string') return false;

  const [contentType, base64Content] = line?.split(';');
  if (!contentType || !base64Content) return false;

  const [, ext] = contentType.split('/');
  if (!ext) return false;

  const [, imageFile] = base64Content.split(',');
  if (!imageFile || imageFile.search(base64Regexp) === -1) return false;

  return true;
};

export function getFormData(payload) {
  const formData = new FormData();

  const flattenPayload = flatten(payload);

  Object.keys(flattenPayload).forEach(key => {
    const value = get(payload, key);

    if (Array.isArray(value)) {
      value.forEach(arrayEl => formData.append(`${key}[]`, arrayEl));
      return;
    }

    if (isBase64(value)) {
      const [, ext] = value.split(';')[0].split('/');
      formData.append(key, Buffer.from(value, 'base64'), `image.${ext}`);
      return;
    }

    if (value !== undefined) {
      formData.set(key, value);
    }
  });

  return formData;
}
